module.exports = __webpack_public_path__ + "img/39-girl.2475d83e.svg";